<h2>Select</h2>
<p class="demo-description">Demonstrates <code>upp-select</code> with options, items, and lists.</p>

<!-- Controls -->
<div class="demo-controls">
    <ion-button size="small" (click)="toggleDisabled()">Disabled: {{ isDisabled }}</ion-button>
</div>

<!-- upp-select with form -->
<div class="demo-section" [formGroup]="form">
    <h3>upp-select with FormGroup</h3>
    <div class="demo-field">
        <label class="demo-label">Country (value: {{ form.get('country')?.value }})</label>
        <upp-select formControlName="country">
            <upp-select-item>
                <ion-item lines="none">
                    <ion-icon name="globe-outline" slot="start"></ion-icon>
                    <ion-label>Select a country</ion-label>
                </ion-item>
            </upp-select-item>
            <upp-select-list>
                <upp-select-option *ngFor="let country of countries" [value]="country.value">
                    <ion-item lines="none" button>
                        <ion-label>{{ country.label }}</ion-label>
                    </ion-item>
                </upp-select-option>
            </upp-select-list>
        </upp-select>
    </div>
</div>

<!-- upp-select standalone -->
<div class="demo-section">
    <h3>upp-select standalone (value: {{ standaloneValue || 'none' }})</h3>
    <div class="demo-field">
        <label class="demo-label">Category</label>
        <upp-select [disabled]="isDisabled" (Changed)="onStandaloneChanged($event)">
            <upp-select-item>
                <ion-item lines="none">
                    <ion-icon name="list-outline" slot="start"></ion-icon>
                    <ion-label>Pick a product</ion-label>
                </ion-item>
            </upp-select-item>
            <upp-select-list>
                <upp-select-option value="pizza">
                    <ion-item lines="none" button>
                        <ion-label>Pizza</ion-label>
                    </ion-item>
                </upp-select-option>
                <upp-select-option value="laptop">
                    <ion-item lines="none" button>
                        <ion-label>Laptop</ion-label>
                    </ion-item>
                </upp-select-option>
                <upp-select-option value="phone">
                    <ion-item lines="none" button>
                        <ion-label>Phone</ion-label>
                    </ion-item>
                </upp-select-option>
                <upp-select-option value="salad">
                    <ion-item lines="none" button>
                        <ion-label>Salad</ion-label>
                    </ion-item>
                </upp-select-option>
            </upp-select-list>
        </upp-select>
    </div>
</div>
